import { formatDate, getDateDifference, pluralize } from '@travelata-libs/utils';

import { DATE_FROM_TEXTS } from '../config/texts';
import type { DateFrom } from '../model/types';
import { getAnchor, getMinDate, parseDate } from './dateFrom';

const DAYS_FORMS = ['день', 'дня', 'дней'];

export function flexCountWord(n: number): string {
  return pluralize(DAYS_FORMS, n);
}

export function formatDdMm(d: Date): string {
  return formatDate(d, 'dd.MM');
}

export function formatDdMmYyyy(d: Date): string {
  return formatDate(d, 'dd.MM.yyyy');
}

function flexCoversRange(value: DateFrom, anchor: Date): boolean {
  if (value.daysFlexible <= 0) {
    return false;
  }
  const daysFromTomorrow = Math.abs(getDateDifference(getMinDate(), anchor, 'days'));
  return daysFromTomorrow >= value.daysFlexible;
}

export function formatDateValue(value: DateFrom, anchor: Date): string {
  const { valuePrefix, rangeJoin, flexSign } = DATE_FROM_TEXTS;

  if (value.from !== value.to) {
    if (flexCoversRange(value, anchor)) {
      return `${valuePrefix}${formatDdMm(anchor)} ${flexSign} ${flexCountWord(value.daysFlexible)}`;
    }
    return `${valuePrefix}${formatDdMm(parseDate(value.from))}${rangeJoin}${formatDdMm(parseDate(value.to))}`;
  }

  return `${valuePrefix}${formatDdMmYyyy(parseDate(value.from))}`;
}

export function formatCheckInLabel(value: DateFrom): string {
  return formatDdMm(getAnchor(value));
}
